module.exports = __webpack_public_path__ + "img/staff-2018-women.dc1da84b.jpg";